import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { BRAND } from '@saesak/shared';
import { SiteFooter } from '@/routes/shared/SiteFooter';

/** 로그인·가입 화면 공통 껍데기 — 여백을 넉넉히 두고 장식을 절제한다 (§7.1) */
export function AuthLayout({
  title,
  description,
  children,
  footer,
}: {
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-screen-sm flex-col justify-center px-6 py-10">
      {/* 브랜딩 클릭 → 첫 화면(/) — PC에서는 서비스 소개 랜딩으로 나가는 출구가 된다 */}
      <Link to="/" className="mb-8 flex flex-col items-center gap-3 text-center">
        <img src="/brand-icon.svg" alt="" width={72} height={72} />
        <div>
          <p className="text-2xl font-bold">{BRAND.name}</p>
          <p className="text-base text-ink-sub">{BRAND.description}</p>
        </div>
      </Link>

      <section className="card animate-rise-in p-5">
        <h1 className="text-xl font-bold">{title}</h1>
        {description && <p className="mt-1 text-base text-ink-sub">{description}</p>}
        <div className="mt-5">{children}</div>
      </section>

      {footer && <div className="mt-5 text-center text-sm text-ink-sub">{footer}</div>}

      <p className="mt-6 text-center text-xs text-ink-sub">
        가입·로그인 시{' '}
        <Link to="/terms" className="underline">
          이용약관
        </Link>
        과{' '}
        <Link to="/privacy" className="underline">
          개인정보 처리방침
        </Link>
        에 동의한 것으로 봅니다.
      </p>

      <SiteFooter />
    </main>
  );
}
